import { Receiver } from './receiver'

export interface NotificationReceiverInterface {
  /**
   * 接收人ReflectionID
   */
  rid: number
  /**
   * 接收人信息
   * *通过参数expend获取*
   */
  receiver?: Receiver
  /**
   * 模板变量
   */
  variables?: string
  /**
   * 是否已读
   */
  isReaded?: boolean
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
}

export class NotificationReceiver implements NotificationReceiverInterface {
  /**
   * 接收人ReflectionID
   */
  rid: number
  /**
   * 接收人信息
   * *通过参数expend获取*
   */
  receiver?: Receiver
  /**
   * 模板变量
   */
  variables?: string
  /**
   * 是否已读
   */
  isReaded?: boolean
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number

  constructor(props: NotificationReceiverInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      rid: _rid,
      receiver: _receiver,
      variables: _variables,
      isReaded: _isReaded,
      id: _id,
      schoolId: _schoolId,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.rid = _rid
    this.receiver = _receiver ? new Receiver(_receiver) : _receiver
    this.variables = _variables
    this.isReaded = _isReaded
    this.id = _id
    this.schoolId = _schoolId
  }
}
